export const fragenKommissionsverkauf = [
  {
    question: "Wie lange dauert ein Kommissionsverkauf?",
    answer: (
      <>
        <p>
          Die Dauer hängt vom Fahrzeugtyp und der Marktnachfrage ab. In der
          Regel wird ein Auto innerhalb von 2 bis 6 Wochen verkauft. Du erhältst
          regelmäßige Statusupdates von deinem gewählten Händler.
        </p>
      </>
    ),
  },
  {
    question: "Wer legt den Verkaufspreis fest?",
    answer: (
      <>
        <p>
          Der Preis wird gemeinsam mit dir festgelegt - basierend auf Marktwert,
          Zustand und Nachfrage. Der Händler darf nur innerhalb dieser
          Preisgrenzen verhandeln.
        </p>
      </>
    ),
  },
  {
    question: "Was passiert, wenn kein Käufer gefunden wird?",
    answer: (
      <>
        <p>
          Wenn innerhalb der vereinbarten Kommissionszeit kein Verkauf zustande
          kommt, kannst du entscheiden, ob du die Laufzeit verlängerst oder dein
          Auto zurücknimmst.
        </p>
      </>
    ),
  },
  {
    question: "Wie ist mein Fahrzeug während der Kommission versichert?",
    answer: (
      <>
        <p>
          Während der Kommission bleibt dein Auto voll versichert. Das Risiko
          trägt der Händler, solange das Fahrzeug bei ihm steht oder für
          Probefahrten genutzt wird.
        </p>
      </>
    ),
  },
  {
    question: "Muss ich Gebühren zahlen, wenn kein Verkauf zustande kommt?",
    answer: (
      <>
        <p>
          Nein. Bei Autoeinfachlos fallen keine Kosten an, wenn kein Verkauf
          erfolgt. Die Provision wird für Händler nur bei erfolgreichem Abschluss
          fällig - fair und transparent.
        </p>
      </>
    ),
  },
];
